export default class UF {
  constructor(id, sigla, descricao) {
    this.id = id
    this.sigla = sigla
    this.descricao = descricao
  }
}
